'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitAbsenteeBid = exports.getAbsenteeBidItemId = exports.getAbsenteeBidAmount = exports.getUiAbsenteeBid = exports.ABSENTEE_BID_SUCCESS = exports.ABSENTEE_BID_REQUEST = exports.ABSENTEE_BID_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = require('../modules/modal');

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('../modules/user');

var _config = require('../modules/config');

var _analytics = require('../modules/analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var ABSENTEE_BID_FAIL = exports.ABSENTEE_BID_FAIL = 'la/ui/absenteeBid/FAIL';
var ABSENTEE_BID_REQUEST = exports.ABSENTEE_BID_REQUEST = 'la/ui/absenteeBid/REQUEST';
var ABSENTEE_BID_SUCCESS = exports.ABSENTEE_BID_SUCCESS = 'la/ui/absenteeBid/SUCCESS';

// reducer
var DEFAULT_STATE = {
    bidAmount: null,
    bidPlaced: false,
    isCurrentHighBid: false,
    itemId: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.DISMISS_MODAL:
            return (0, _extends3.default)({}, state, {
                bidPlaced: false
            });
        case _modal.OPEN_ABSENTEE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                bidAmount: action.payload.bidAmount,
                itemId: action.payload.itemId
            });
        case ABSENTEE_BID_REQUEST:
            return (0, _extends3.default)({}, state, {
                bidPlaced: true,
                submitted: true,
                success: false
            });
        case ABSENTEE_BID_SUCCESS:
            return (0, _extends3.default)({}, state, {
                bidAmount: null,
                isCurrentHighBid: action.payload.isCurrentHighBid,
                submitted: false,
                success: true
            });
        case ABSENTEE_BID_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.absenteeBid;
};

var getUiAbsenteeBid = exports.getUiAbsenteeBid = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getAbsenteeBidAmount = exports.getAbsenteeBidAmount = (0, _reselect.createSelector)(getUiAbsenteeBid, function (uiState) {
    return !isNaN(uiState.bidAmount) ? uiState.bidAmount : null;
});

var getAbsenteeBidItemId = exports.getAbsenteeBidItemId = (0, _reselect.createSelector)(getUiAbsenteeBid, function (uiState) {
    return uiState.itemId ? uiState.itemId : null;
});

/* ACTION CREATORS */
var submitAbsenteeBid = exports.submitAbsenteeBid = function submitAbsenteeBid(details) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            type: ABSENTEE_BID_REQUEST
        });
        return _api.Bid.postPlaceAbsenteeBid({ authToken: authToken, deployment: deployment, details: details }).then(function (response) {
            var analytics = (0, _analytics.getPlacedAbsenteeBidAnalytics)(state, details.itemId, details.bidAmount);
            dispatch({
                meta: {
                    actionTime: Date.now(),
                    analytics: analytics.analytics,
                    itemId: details.itemId
                },
                payload: response,
                type: ABSENTEE_BID_SUCCESS
            });
        }).catch(function (error) {
            dispatch({
                error: true,
                payload: error,
                type: ABSENTEE_BID_FAIL
            });
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/absenteeBid.js
// module id = 5Fhj
// module chunks = 57